import { container, singleton } from "tsyringe";
import { Config } from "../config";
import { fetchAndThrowHttpErrors, uuidv4 } from "../utils/helpers";

import { BehaviorSubject } from 'rxjs';
import { TemplateType, Template, TemplatePosition } from '../models/templateClass';

import * as R from 'ramda';
import { ActionType, GroupType } from '../models/actionClass';
import { AssetManagementService } from './asset-management-service';
import { Asset, tagMediaTypeMapping } from '../models/assetClass';
import { MediaOrigin, MediaType } from '../models/mediaClass';

@singleton()
export class TemplateService {

  private assetsService: AssetManagementService = container.resolve(AssetManagementService);

  public lowerthirds$: BehaviorSubject<Template[]> = new BehaviorSubject<any[]>([]);
  public tickers$: BehaviorSubject<Template[]> = new BehaviorSubject<any[]>([]);
  public nametags$: BehaviorSubject<Template[]> = new BehaviorSubject<any[]>([]);
  public logos$: BehaviorSubject<Template[]> = new BehaviorSubject<any[]>([]);

  public selectedLowerthird$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public selectedTicker$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public selectedLogos$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  private ResourcesUrl = `${Config.DASHBOARD_URL}${process.env.PUBLIC_URL}`;
  private TemplateUrl = `${this.ResourcesUrl}/templates/`;
  private LogoUrl = this.ResourcesUrl;

  constructor() {

    const primaryColor = localStorage.getItem('primaryColor') || '#0D62C5';
    // to be replaced with a server GET to get all predefined images for our channel

    let predefinedLowerThirds = [
      { id: "ae399491-b1e1-4c69-911b-c92ec52dd45c", type: TemplateType.T_LOWERTHIRD, primaryText: 'Welcome to the Studio Demo', secondaryText: 'Have fun exploring Studio features!', name: 'lower_third_template' }
    ];

    let predefinedTickers = [
      { id: "ec72f45b-8bbe-484e-832a-db459fa76fa3", type: TemplateType.T_TICKER, primaryText: 'BlueJeans by Verizon empowers organizations with secure video meeting collaboration and large interactive events for a work-from-anywhere world.', secondaryText: '', name: 'ticker_template' },
      { id: "80259abc-55ae-4837-9f82-7d6ac4640912", type: TemplateType.T_TICKER, primaryText: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla imperdiet cursus purus, a luctus lectus semper eget. Curabitur et malesuada ligula, quis posuere eros. Aliquam euismod ac est ut gravida. Fusce eu dolor iaculis, iaculis ex ac, sodales quam. Suspendisse rhoncus tortor in justo scelerisque, fermentum pellentesque felis finibus. Aenean sit amet velit ut risus eleifend pulvinar. Donec et auctor dui, sed scelerisque sapien. Pellentesque lectus libero, iaculis ac mauris sit amet, volutpat ullamcorper felis. Sed condimentum magna elit, pharetra pulvinar dui convallis eget. Donec eu mollis augue, et mattis eros. Ut maximus massa nunc, ut pellentesque justo pellentesque id. Fusce rutrum felis vel lacus laoreet finibus. Integer faucibus fringilla risus, ut interdum est.', secondaryText: '', name: 'ticker_template' },
    ];

    let predefinedLogos = [
      { id: "8e1613b4-7ec1-4656-b7fc-b215ffe4578", type: TemplateType.T_LOGO, name: 'BlueJeans', source: this.LogoUrl + '/logos/bluejeans.png', position: TemplatePosition.TOP_RIGHT },
      { id: "2aa33f52-d263-46b7-b115-4d27381c26d7", type: TemplateType.T_LOGO, name: 'Studio', source: this.LogoUrl + '/logos/studio.png', position: TemplatePosition.BOTTOM_RIGHT },
      { id: "6663a841-780b-4c2a-980e-71ccd2431d21", type: TemplateType.T_LOGO, name: 'Verizon', source: this.LogoUrl + '/logos/verizon.png', position: TemplatePosition.BOTTOM_LEFT },
      { id: "d1ae36a7-5c1f-4608-bc65-b12b4f450cb7", type: TemplateType.T_LOGO, name: '5G', source: this.LogoUrl + '/logos/5g.png', position: TemplatePosition.BOTTOM_RIGHT },
    ];


    localStorage.removeItem('lowerthirds');
    localStorage.removeItem('tickers');
    localStorage.removeItem('logos');

    const lsTickers = localStorage.getItem('tickers-v2');
    if (lsTickers) {
      try {
        predefinedTickers = JSON.parse(lsTickers);
      } catch (e) { }
    }
    const lsLowerThirds = localStorage.getItem('lowerthirds-v2');
    if (lsLowerThirds) {
      try {
        predefinedLowerThirds = JSON.parse(lsLowerThirds);
      } catch (e) { }
    }
    // const lsLogos = localStorage.getItem('logos-v2');
    // if (lsLogos) {
    //   try {
    //     predefinedLogos = JSON.parse(lsLogos);
    //   } catch (e) { }
    // }

    const lowerthirds = [];
    for (const lt of predefinedLowerThirds) {
      const source = this.TemplateUrl + lt.name;
      const template = new Template(lt.id, source, lt.name, lt.name, lt.primaryText, lt.secondaryText, lt.type, 10000, primaryColor, false, 'transparent', '', MediaOrigin.PREDEFINED);
      if (template.id === 'ae399491-b1e1-4c69-911b-c92ec52dd45c') {
        template.selected = true;
      }
      lowerthirds.push(template);
    }
    console.log('%%%', lowerthirds);
    this.lowerthirds$.next(lowerthirds);

    const tickers = [];
    for (const ti of predefinedTickers) {
      const source = this.TemplateUrl + ti.name;
      const template = new Template(ti.id, source, ti.name, ti.name, ti.primaryText, ti.secondaryText, ti.type, 10001, primaryColor, false, 'transparent', '', MediaOrigin.PREDEFINED);
      tickers.push(template);
    }
    console.log('%%%', tickers);
    this.tickers$.next(tickers);

    const logos = [];
    for (const lg of predefinedLogos) {
      const template = new Template(lg.id, lg.source, lg.name, lg.name, '', '', lg.type, 10002, primaryColor, false, 'transparent', '', MediaOrigin.PREDEFINED);
      template.position = lg.position;
      logos.push(template);
    }
    console.log('%%%', logos);
    this.logos$.next(logos);

    this.nametags$.next([]);

    this.getUserAssets();
  }

  processAssets = (origin: MediaOrigin, assets: Asset[], type: MediaType, categoryCollection) => {

    const assetLastUploadDate = parseInt(localStorage.getItem('assetLastUploadDate') || Number.MAX_SAFE_INTEGER.toString());

    const primaryColor = localStorage.getItem('primaryColor') || '#0D62C5';

    let templatesInCategory = categoryCollection.getValue().filter(t => t.origin === MediaOrigin.PREDEFINED);
    console.log("will load assets into medias ", type, assets)
    if (assets && assets.length && assets.length > 0) {
      const templates = [];
      for (const a of assets) {
        let templ = null;
        const assetType = tagMediaTypeMapping[a.tag] || MediaType.BG_IMAGE;

        // check asset type is the one we looking for
        if (assetType === type) {

          if (type === MediaType.LOGO) {

            templ = new Template(a.id, a.assetDownloadUrl, a.title, a.title, '', '', assetType, 10002, primaryColor, false, 'transparent', '', MediaOrigin.USER_ASSET);
          }
          templ.isNew = (a.createdDate > assetLastUploadDate);
          templ.origin = origin;
          templates.push(templ);
        }
      }
      // add users assets before predefined
      categoryCollection.next([...templates, ...templatesInCategory]);
    }
  }

  getUserAssets = () => {
    // get last uploaded asset
    this.assetsService.assetList$.subscribe((assets: Asset[]) => {
      this.processAssets(MediaOrigin.USER_ASSET, assets, MediaType.LOGO, this.logos$);;
    })
    // get organizer's asset
    this.assetsService.assetListOrg$.subscribe((assets: Asset[]) => {
      this.processAssets(MediaOrigin.MEETING_ASSET, assets, MediaType.LOGO, this.logos$);;
    })
  }


  addDefault(type) {
    const primaryColor = localStorage.getItem('primaryColor') || '#0D62C5';

    if (type === TemplateType.T_LOWERTHIRD) {
      const lt = { id: uuidv4(), type: TemplateType.T_LOWERTHIRD, primaryText: '', secondaryText: '', name: 'lower_third_template', };
      const source = this.TemplateUrl + lt.name;

      const template = new Template(lt.id, source, lt.name, lt.name, lt.primaryText, lt.secondaryText, lt.type, 10000, primaryColor, true, 'transparent', '', MediaOrigin.USER_ASSET);

      const lowerthirds = R.clone(this.lowerthirds$.getValue()); // clone to force update
      lowerthirds.unshift(template);
      this.lowerthirds$.next(lowerthirds);
      return template;

    } else if (type === TemplateType.T_TICKER) {

      const ticker = { id: uuidv4(), type: TemplateType.T_TICKER, primaryText: '', secondaryText: '', name: 'ticker', };  // keep secondary even if not used - common code use it
      const source = this.TemplateUrl + 'ticker_template';

      const template = new Template(ticker.id, source, ticker.name, ticker.name, ticker.primaryText, ticker.secondaryText, ticker.type, 10001, primaryColor, true, 'transparent', '', MediaOrigin.USER_ASSET);

      const tickers = R.clone(this.tickers$.getValue()); // clone to force update
      tickers.unshift(template);
      this.tickers$.next(tickers);
      return template;

    } else if (type === TemplateType.T_LOGO) {

      const logo = { id: uuidv4(), type: TemplateType.T_LOGO, primaryText: '', secondaryText: '', name: 'logo', };  // keep secondary even if not used - common code use it
      const source = this.LogoUrl + 'logo';

      const template = new Template(logo.id, source, logo.name, logo.name, logo.primaryText, logo.secondaryText, logo.type, 10001, primaryColor, true, 'transparent', '', MediaOrigin.USER_ASSET);

      const logos = R.clone(this.logos$.getValue()); // clone to force update
      logos.unshift(template);
      this.logos$.next(logos);
      return template;

    }
    return null;
  }

  async remove(type, id, mediaOrigin: MediaOrigin) {
    if (type === TemplateType.T_LOWERTHIRD) {
      const lowerthirds = R.clone(this.lowerthirds$.getValue().filter(lt => lt.id !== id));
      this.lowerthirds$.next(lowerthirds);
      if (lowerthirds.length > 0) {
        localStorage.setItem('lowerthirds-v2', JSON.stringify(lowerthirds));
      } else {
        localStorage.removeItem('lowerthirds-v2');
      }

    } else if (type === TemplateType.T_TICKER) {

      const tickers = R.clone(this.tickers$.getValue().filter(ti => ti.id !== id));
      this.tickers$.next(tickers);
      if (tickers.length > 0) {
        localStorage.setItem('tickers-v2', JSON.stringify(tickers));
      } else {
        localStorage.removeItem('tickers-v2');
      }

    } else if (type === TemplateType.T_LOGO) {

      const logos = R.clone(this.logos$.getValue().filter(lg => lg.id !== id));
      this.logos$.next(logos);
      const flogos = logos.filter(i => i.origin === MediaOrigin.PREDEFINED);
      if (flogos.length > 0) {
        localStorage.setItem('logos-v2', JSON.stringify(flogos));
      } else {
        localStorage.removeItem('logos-v2');
      }
    }

    if (mediaOrigin === MediaOrigin.USER_ASSET) {
      // is media a user asset ?
      await this.assetsService.deleteAsset(id);
      // setTimeout(() => {
      //   this.assetsService.loadAssets();
      // }, 5000);
    }

  }


  save(type, template) {
    if (type === TemplateType.T_LOWERTHIRD) {
      let lowerthirds = [...this.lowerthirds$.getValue()];  // clone to force update
      const lt = lowerthirds.find(lt => lt.id === template.id);
      if (lt) {
        lt.isNew = template.isNew;
        // lt.selected = template.selected;
        lt.isAdding = false;
        lt.primaryText = R.clone(template.primaryText);
        lt.secondaryText = R.clone(template.secondaryText);
        lt.primaryColor = R.clone(template.primaryColor);
        this.lowerthirds$.next(lowerthirds);
        if (lowerthirds.length > 0) {
          localStorage.setItem('lowerthirds-v2', JSON.stringify(lowerthirds));
        } else {
          localStorage.removeItem('lowerthirds-v2');
        }
      }

    } else if (type === TemplateType.T_TICKER) {

      let tickers = [...this.tickers$.getValue()];  // clone to force update
      const ticker = tickers.find(ti => ti.id === template.id);
      if (ticker) {
        ticker.isNew = template.isNew;
        // ticker.selected = template.selected;
        ticker.isAdding = false;
        ticker.primaryText = R.clone(template.primaryText);
        ticker.secondaryText = R.clone(template.secondaryText);
        ticker.primaryColor = R.clone(template.primaryColor);
        this.tickers$.next(tickers);
        if (tickers.length > 0) {
          localStorage.setItem('tickers-v2', JSON.stringify(tickers));
        } else {
          localStorage.removeItem('tickers-v2');
        }
      }

    } else if (type === TemplateType.T_LOGO) {

      let logos = [...this.logos$.getValue()];  // clone to force update
      const logo = logos.find(lg => lg.id === template.id);
      if (logo) {
        const isRenamed = (logo.name !== template.name);
        logo.isNew = template.isNew;
        logo.selected = template.selected;
        logo.isAdding = false;
        logo.primaryText = '';
        logo.secondaryText = '';
        logo.primaryColor = R.clone(template.primaryColor);
        logo.source = R.clone(template.source);
        logo.name = R.clone(template.name);
        logo.position = R.clone(template.position);
        this.logos$.next(logos);

        const flogos = logos.filter(i => i.origin === MediaOrigin.PREDEFINED);
        if (flogos.length > 0) {
          localStorage.setItem('logos-v2', JSON.stringify(flogos));
        } else {
          localStorage.removeItem('logos-v2');
        }

        if (isRenamed && logo.origin === MediaOrigin.USER_ASSET) {
          // update name in assets
          this.assetsService.renameAsset(logo.id, logo.name);
        }
      }
    }
  }

  processAttributes(templateAttributes: any) {

    // process attributes to get status for lowerThird and tickers

    const lowerthirds = R.clone(this.lowerthirds$.getValue());
    const tickers = R.clone(this.tickers$.getValue());
    const logos = R.clone(this.logos$.getValue());

    let tickerSelected = false;
    let lowerthirdSelected = false;
    let selectedLogos = [];

    if (templateAttributes.attributes) {
      for (const template of templateAttributes.attributes) {
        if (template.type === TemplateType.T_LOWERTHIRD || template.type === TemplateType.T_TICKER || template.type === TemplateType.T_LOGO) {

          // find lowerthird id in lowerthird$
          const match =
            (template.type === TemplateType.T_LOWERTHIRD ? lowerthirds.find(lt => lt.id === template.id) : (template.type === TemplateType.T_TICKER ? tickers.find(t => t.id === template.id) :
              logos.find(t => t.id === template.id)
            ));
          if (match) {
            if (template.type === TemplateType.T_LOWERTHIRD) {
              this.selectedLowerthird$.next(template.id);
              lowerthirdSelected = true;
              match.selected = template.isVisible;
              match.primaryText = template.primaryText;
              match.secondaryText = template.secondaryText;
              match.primaryColor = template.primaryColor;
              this.save(template.type, match);

            } else if (template.type === TemplateType.T_TICKER) {
              this.selectedTicker$.next(template.id);
              tickerSelected = true;
              match.selected = template.isVisible;
              match.primaryText = template.primaryText;
              match.primaryColor = template.primaryColor;
              this.save(template.type, match);

            } else if (template.type === TemplateType.T_LOGO) {
              if (template.isVisible) {
                selectedLogos.push(template.id);
              }
              match.name = template.name;
              match.model = template.model;
              match.source = template.source;
              match.position = template.positionName;  // use TOP_LEFT, TOP_RIGHT ... not position{x,y}
            }
          } else if (template.id) {
            console.log('add missing template:', JSON.stringify(template));

            // no match => add a new lowerthird/ticker/logo
            const newTemp = this.addDefault(template.type);
            newTemp.id = template.id; // use template id
            newTemp.isNew = true;
            newTemp.selected = false;
            newTemp.primaryText = template.primaryText;
            newTemp.secondaryText = template.secondaryText || '';
            newTemp.primaryColor = template.primaryColor; // use color of template - can be different than the on of brandsettings
            newTemp.source = template.source;
            newTemp.name = template.name;
            if (template.positionName) {
              newTemp.position = template.positionName;
            } else if (template.type === TemplateType.T_LOGO) {
              newTemp.position = TemplatePosition.TOP_RIGHT;
              newTemp.name = 'logo debug 1';
            }

            // push newTemp in queue
            this.save(template.type, newTemp);

            if (template.type === TemplateType.T_LOWERTHIRD) {
              this.selectedLowerthird$.next(template.id);
              lowerthirdSelected = true;
            } else if (template.type === TemplateType.T_TICKER) {
              this.selectedTicker$.next(template.id);
              tickerSelected = true;
            } else if (template.type === TemplateType.T_LOGO) {
              selectedLogos.push(template.id);
            }
          }
        }
      }
    }

    if (!lowerthirdSelected) {
      this.selectedLowerthird$.next('');
    }
    if (!tickerSelected) {
      this.selectedTicker$.next('');
    }

    // update first logos before selected
    this.logos$.next(logos);
    this.selectedLogos$.next(selectedLogos);
    console.log('NEW .LOGOS', logos);

  }

  processUpdate(reason) {

    console.log('REASON', reason);

    if (reason.group !== GroupType.LOGO &&
      reason.group !== GroupType.LOWERTHIRD &&
      reason.group !== GroupType.TICKER) {
      return;
    }
    if (reason.action === ActionType.REMOVE) {
      this.remove(reason.group, reason.id, MediaOrigin.MEETING_ASSET);
    }
    else if (reason.action === ActionType.RENAME) {
      if (reason.group === GroupType.LOGO) {
        reason.value.isNew = true;
        this.save(reason.group, reason.value);
      }
    }

  }

}
